// @flow
import api from '../api/feedback';
import { createSelector } from 'reselect';
import { getHelpScoutInformation } from './config';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const RESET_FEEDBACK_MODAL = 'la/ui/submitFeedback/RESET';
export const SUBMIT_FEEDBACK_FAIL = 'la/ui/submitFeedback/FAIL';
export const SUBMIT_FEEDBACK_REQUEST = 'la/ui/submitFeedback/REQUEST';
export const SUBMIT_FEEDBACK_SUCCESS = 'la/ui/submitFeedback/SUCCESS';

export const FETCH_HELPSCOUT_TOKEN_FAIL = 'la/ui/fetchHelpScoutToken/FAIL';
export const FETCH_HELPSCOUT_TOKEN_REQUEST = 'la/ui/fetchHelpScoutToken/REQUEST';
export const FETCH_HELPSCOUT_TOKEN_SUCCESS = 'la/ui/fetchHelpScoutToken/SUCCESS';

// reducer
const DEFAULT_STATE = {
    accessToken: '',
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case RESET_FEEDBACK_MODAL:
            return {
                ...state,
                submitted: false,
                success: false,
            };
        case SUBMIT_FEEDBACK_FAIL:
            return {
                ...state,
                submitted: false,
                success: false,
            };
        case SUBMIT_FEEDBACK_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case SUBMIT_FEEDBACK_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case FETCH_HELPSCOUT_TOKEN_FAIL:
            return {
                ...state,
            };
        case FETCH_HELPSCOUT_TOKEN_REQUEST:
            return {
                ...state,
            };
        case FETCH_HELPSCOUT_TOKEN_SUCCESS:
            return {
                ...state,
                accessToken: action.payload,
            };
        default:
            return state;
    }
}
/* SELECTORS */
const feedbackSelector = (state: GlobalState) => state.feedback;

export const getAccessToken = createSelector(feedbackSelector, state => state.accessToken);

export const getSubmitted = createSelector(feedbackSelector, state => state.submitted);

export const getSuccess = createSelector(feedbackSelector, state => state.success);

/* ACTION CREATORS */
export const resetModal = () => ({
    type: RESET_FEEDBACK_MODAL,
});

type SubmitFeedbackParams = {
    currentURL: any,
    email: any,
    feedback: any,
    fullStorySessionId: any,
    isBiddingConsole: any,
};
export const submitFeedback = ({
    currentURL,
    email,
    feedback,
    fullStorySessionId,
    isBiddingConsole,
}: SubmitFeedbackParams) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const { access_token: authToken } = getAccessToken(state);
        const feedbackType = isBiddingConsole ? 'live bidding feedback' : 'Site Feedback';
        const feedbackObject = {
            // must be exact format for date, slice removes milliseconds.
            createdAt: new Date().toISOString().slice(0, 19) + 'Z',
            customer: {
                email,
            },
            mailboxId: 168062,
            status: 'active',
            subject: feedbackType,
            tags: [feedbackType],
            threads: [
                {
                    customer: {
                        email,
                    },
                    text: `${feedback}

                    Session ID: ${fullStorySessionId}
                    Current URL: ${currentURL}`,
                    type: 'customer',
                },
            ],
            type: 'email',
        };
        dispatch({
            payload: {
                email,
                feedback: feedbackObject,
            },
            type: SUBMIT_FEEDBACK_REQUEST,
        });
        await api.submitFeedback({
            authToken,
            feedbackObject,
        });
        dispatch({
            payload: {
                email,
                feedback: feedbackObject,
            },
            type: SUBMIT_FEEDBACK_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: SUBMIT_FEEDBACK_FAIL,
        });
    }
};

export const fetchHelpScoutToken = () => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const helpScoutInformation = getHelpScoutInformation(state);
        dispatch({
            type: FETCH_HELPSCOUT_TOKEN_REQUEST,
        });

        const response = await api.fetchHelpScoutToken(helpScoutInformation);
        dispatch({
            payload: response,
            type: FETCH_HELPSCOUT_TOKEN_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: FETCH_HELPSCOUT_TOKEN_FAIL,
        });
    }
};
